import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Grid, Database, Zap, RefreshCw } from 'lucide-react';
import SmartGrid from '../hivecore/smartgrid.js';

const WealthOSSmartGrid: React.FC = () => {
  const [isAutoRefreshActive, setIsAutoRefreshActive] = useState(true);

  return (
    <div className="h-full bg-slate-900 flex flex-col">
      <div className="flex-shrink-0 p-6 border-b border-slate-700/50">
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
          className="flex items-center justify-between"
        >
          <div className="flex items-center gap-3">
            <div className="p-2 bg-teal-500/20 rounded-lg">
              <Grid className="w-6 h-6 text-teal-400" />
            </div>
            <div>
              <h1 className="text-2xl font-bold text-white text-drop-shadow">WealthOS SmartGrid</h1>
              <p className="text-slate-400">Intelligent spreadsheet for tax and financial data</p>
            </div>
          </div>
          
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-2 px-3 py-1.5 bg-slate-800/50 rounded-lg border border-slate-700/50">
              <Database className="w-4 h-4 text-blue-400" />
              <span className="text-sm text-slate-300">BeeMemory Connected</span>
            </div>
            
            <div className="flex items-center gap-2 px-3 py-1.5 bg-slate-800/50 rounded-lg border border-slate-700/50">
              <Zap className="w-4 h-4 text-yellow-400" />
              <span className="text-sm text-slate-300">Formulas Active</span>
            </div>
            
            <div 
              className={`flex items-center gap-2 px-3 py-1.5 bg-slate-800/50 rounded-lg border border-slate-700/50 cursor-pointer transition-colors ${
                isAutoRefreshActive ? 'hover:bg-slate-700/50' : 'opacity-60'
              }`}
              onClick={() => setIsAutoRefreshActive(!isAutoRefreshActive)}
            >
              <RefreshCw className={`w-4 h-4 text-green-400 ${isAutoRefreshActive ? 'animate-spin' : ''}`} />
              <span className="text-sm text-slate-300">
                Auto-Refresh {isAutoRefreshActive ? 'On' : 'Off'}
              </span>
            </div>
          </div>
        </motion.div>
      </div>
      
      <div className="flex-1 overflow-hidden">
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.4, delay: 0.1 }}
          className="h-full"
        >
          <SmartGrid />
        </motion.div>
      </div>
    </div>
  );
};

export default WealthOSSmartGrid;
